import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "authors-title"
};
const _hoisted_2 = {
  class: "authors-block"
};
const _hoisted_3 = {
  class: "authors-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.rows, (row, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "authors-section",
      key: index
    }, [_createElementVNode("div", _hoisted_1, _toDisplayString(row.period), 1), _createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "authors-col",
        key: 'row-' + index
      }, [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: 'row-col-' + index
        }, [_createVNode(_component_router_link, {
          to: {
            name: 'author',
            params: {
              id: item.id
            }
          },
          style: {
            "cursor": "pointer"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["to"])]);
      }), 128))])]);
    }), 128))])]);
  }), 128);
}